import * as ls from 'local-storage'
import axios, { AxiosRequestConfig } from 'axios'
import { ApiAnswerStatus } from '../types/default-types'

enum TOKEN {
  PUBLIC = 'token_public',
  PRIVATE = 'token_private',
}

const { REACT_APP_API_URL = '/', REACT_APP_API_AUTH, REACT_APP_PORTAL_URL: PORTAL } = process.env
const axiosClient = axios.create({
  baseURL: `${REACT_APP_API_URL.replace(/^\/+/, '')}/`,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Basic ${REACT_APP_API_AUTH}`,
  },
})

const apiFetchData = async (config: AxiosRequestConfig) => {
  return await axiosClient
    .request(config)
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      throw e
    })
}

export const reFetchPrivateAPIToken = (refreshToken: string) =>
  apiFetchData({
    url: '/oauth/refresh',
    method: 'post',
    data: {
      refresh_token: refreshToken,
    },
  })

const fetchPrivateAPIToken = async (username: string, password: string) =>
  await apiFetchData({
    url: '/oauth/token',
    method: 'post',
    data: { username, password },
  })
    .then((res: any) => {
      ls.set(TOKEN.PRIVATE, res.data)
    })
    .catch((e) => {
      throw e
    })

const withPrivateAPIToken = async (config: AxiosRequestConfig) => {
  const token = ls.get<{ access_token?: string; refresh_token?: string }>(TOKEN.PRIVATE)

  if (!(token && token.access_token)) {
    return apiFetchData(config)
  } else {
    return await apiFetchData({ ...config, headers: { Authorization: `Bearer ${token.access_token}` } })
      .then((res: any) => {
        return res
      })
      .catch((e) => {
        if (e.response.status === ApiAnswerStatus.UNAUTHENTICATED) {
          return reFetchPrivateAPIToken(token.refresh_token || '')
            .then((result: any) => {
              ls.remove(TOKEN.PRIVATE)
              ls.set(TOKEN.PRIVATE, result.data)

              return apiFetchData({ ...config, headers: { Authorization: `Bearer ${result.data.access_token}` } })
            })
            .catch((err) => {
              if (err.response.status === ApiAnswerStatus.UNAUTHENTICATED) {
                ls.remove(TOKEN.PRIVATE)
                throw err
              } else {
                return apiFetchData({ ...config })
              }
            })
        } else if (e.response.status === ApiAnswerStatus.NEED_FULL_REGISTER) {
          throw e.response
        } else if (e.response.status === ApiAnswerStatus.FORBIDDEN) {
          window.location.href = `${PORTAL}`
          throw e.response
        } else {
          throw e
        }
      })
  }
}

const withPublicAPIToken = async (config: AxiosRequestConfig) => {
  return await apiFetchData({ ...config })
    .then((res: any) => {
      return res
    })
    .catch((e) => {
      console.error('ошибка public запроса', e)
      throw e
    })
}

const signout = async () => {
  return withPrivateAPIToken({
    url: '/private/session/logout',
    method: 'get',
  }).then((_r) => {
    ls.remove(TOKEN.PRIVATE)
  })
}

export { apiFetchData, withPrivateAPIToken, withPublicAPIToken, fetchPrivateAPIToken, signout }
